"use strict";
var ErrorObservable_1 = require('./ErrorObservable');
exports._throw = ErrorObservable_1.ErrorObservable.create;
//# sourceMappingURL=throw.js.map


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/~/rxjs/observable/throw.js
// module id = ../../../../rxjs/observable/throw.js
// module chunks = 3